import {CanActivateFn} from '@angular/router';
import {Router} from '@angular/router';
import {inject} from '@angular/core';
import {Store} from '@ngrx/store';
import {
  selectIsUserDataLoaded,
  selectUserHasPermission,
} from '../store/user-info/user-info.selector';
import {Entity, UserPrivilege} from '../../features/main-page/types';
import {
  combineLatest,
  map,
  filter,
  switchMap,
  take,
  timeout,
  catchError,
  of,
} from 'rxjs';

export const privilegeGuard: CanActivateFn = (route) => {
  const store = inject(Store);
  const router = inject(Router);
  const requiredPrivileges = route.data?.['privileges'] as Entity[];

  if (!requiredPrivileges?.length) {
    return true;
  }

  return store.select(selectIsUserDataLoaded).pipe(
    filter((isLoaded) => isLoaded), // If it isn't loaded we don't want the flow to continue
    take(1), // Take only the first emission where isLoaded is true
    switchMap(() => {
      const privilegeChecks = requiredPrivileges.map((privilege) =>
        store.select(
          selectUserHasPermission(`${privilege}_READ` as UserPrivilege),
        ),
      );

      return combineLatest(privilegeChecks).pipe(
        map((results) => {
          // Return true only if all privileges are granted
          const hasAccess = results.some(Boolean);

          if (!hasAccess) {
            router.navigateByUrl(router.createUrlTree(['/forbidden']));
          }

          return hasAccess;
        }),
        take(1), // Take only the first result
      );
    }),
    catchError((error) => {
      console.error(
        'Privilege guard: timeout or error waiting for user data:',
        error,
      );
      // On timeout or error, deny access and redirect to forbidden
      router.navigateByUrl(router.createUrlTree(['/forbidden']));
      return of(false);
    }),
  );
};
